// extracted by mini-css-extract-plugin
module.exports = {"texts":"texts--2THpo","texts__unit":"texts__unit--1Nnve","texts__unit-title":"texts__unit-title--3xcCO","texts__button-container":"texts__button-container--18NDt"};